<template lang="pug">

q-layout(view="hhh LpR fff")
  //- Layout
  Header

  //- Body
  q-page-container
    q-page
      Body

</template>

<style>
</style>

<script>
import Header from "./_comps/Header.vue"
import Body from "./_comps/Body.vue"

export default {
  components: {
    Header,
    Body
  },
}
</script>
